export const isJSON = string => {
  try {
    JSON.parse(string);
  } catch (e) {
    return false;
  }
  return true;
};

export const clearItem = key => (key
  ? window.localStorage.removeItem(key)
  : window.localStorage.clearImmediate());

export const getItem = key => {
  const relevantItem = window.localStorage.getItem(key);

  if (relevantItem) return isJSON(relevantItem) ? JSON.parse(relevantItem) : relevantItem;

  return undefined;
};

export const setItem = (key, value) => window.localStorage.setItem(key, JSON.stringify(value));
